import { YieldType } from "../../../service/globalTypes";
import { StatusCodes } from "../types";

const TOO_MANY_REQUESTS_STATUS_CODE = 429;
const STATUS_CODE_500 = 500;
const STATUS_CODE_400 = 400;

export const validateStatusCodes = (codes: StatusCodes) => {
  const yieldsValidationStatus: { ask: null | boolean; bid: null | boolean } = { bid: null, ask: null };

  [YieldType.ASK, YieldType.BID].forEach((yieldType) => {
    const statusCode = codes[yieldType];

    if (!statusCode) yieldsValidationStatus[yieldType] = false;

    if (statusCode >= STATUS_CODE_500) yieldsValidationStatus[yieldType] = true;
    if (statusCode >= STATUS_CODE_400) {
      if (statusCode === TOO_MANY_REQUESTS_STATUS_CODE) {
        yieldsValidationStatus[yieldType] = true;
        return;
      }

      yieldsValidationStatus[yieldType] = false;
    }
  });

  return yieldsValidationStatus;
};
